function insertUrlImage(data: string): string {
  return data.replaceAll('<img src="/uploads', `<img src="${import.meta.env.VITE_APP_STRAPI_URL}/uploads`)
}

export { insertUrlImage }
